import { DashboardResponse, GetUsersParams, GetUsersResponse } from '@/types';
import { apiSlice } from './apiSlice';

export const usersApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query<GetUsersResponse, GetUsersParams>({
      query: ({ skip = 0, take = 10, search = '', userRegisterType }) => ({
        url: '/users',
        params: { skip, take, search, userRegisterType },
      }),
      providesTags: ['Users'],
    }),
    updateUserStatus: builder.mutation<void, { userId: number; status: 'Active' | 'Blocked' }>({
      query: ({ userId, status }) => ({
        url: `/users/${userId}/${status}`,
        method: 'POST',
      }),
      invalidatesTags: ['Users'],
    }),
    getUsersAnalytics: builder.query<DashboardResponse, void>({
      query: () => ({
        url: '/analytics',
      }),
      providesTags: ['Users'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetUsersQuery, useGetUsersAnalyticsQuery, useUpdateUserStatusMutation } =
  usersApi;
